import { getValueByProp } from "@/utils/object";
import moment, { Moment } from "moment";
import { DATE_PICKER_FORMAT, DATETIME_PICKER_FORMAT, DEFAULT_VALUE, LOG_DATE_FORMAT } from "@/config";

/**
 * @description 生成唯一 uuid
 * @returns {String}
 */
export function generateUUID() {
    let uuid = "";
    for (let i = 0; i < 32; i++) {
        const random = (Math.random() * 16) | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) uuid += "-";
        uuid += (i === 12 ? 4 : i === 16 ? (random & 3) | 8 : random).toString(16);
    }
    return uuid;
}

/**
 * @description 使用递归扁平化菜单，方便添加动态路由
 * @param {Array} menuList 菜单列表
 * @returns {Array}
 */
export function getFlatMenuList(menuList: Menu.MenuOptions[]): Menu.MenuOptions[] {
    const newMenuList: Menu.MenuOptions[] = JSON.parse(JSON.stringify(menuList));
    return newMenuList.flatMap(item => [item, ...(item.children ? getFlatMenuList(item.children) : [])]);
}

/**
 * @description 使用递归过滤出需要渲染在左侧菜单的列表 (需剔除 isHide == true 的菜单)
 * @param {Array} menuList 菜单列表
 * @returns {Array}
 * */
export function getShowMenuList(menuList: Menu.MenuOptions[]) {
    const newMenuList: Menu.MenuOptions[] = JSON.parse(JSON.stringify(menuList));
    return newMenuList.filter(item => {
        if (item.children?.length) {
            item.children = getShowMenuList(item.children);
        }
        return !item.meta?.isHide;
    });
}

/**
 * @description 使用递归找出所有面包屑存储到 pinia/vuex 中
 * @param {Array} menuList 菜单列表
 * @param {Array} parent 父级菜单
 * @param {Object} result 处理后的结果
 * @returns {Object}
 */
export const getAllBreadcrumbList = (menuList: Menu.MenuOptions[], parent = [], result: { [key: string]: unknown } = {}) => {
    for (const item of menuList) {
        result[item.path] = [...parent, item];
        if (item.children) getAllBreadcrumbList(item.children, result[item.path], result);
    }
    return result;
};

/**
 * @description 使用递归过滤需要缓存的菜单 name (该函数暂未使用)
 * @param {Array} menuList 所有菜单列表
 * @param {Array} keepAliveNameArr 缓存的菜单 name ['**','**']
 * @returns {Array}
 * */
export function getKeepAliveRouterName(menuList: Menu.MenuOptions[], keepAliveNameArr: string[] = []) {
    menuList.forEach(item => {
        if (item.meta.isKeepAlive && item.name) keepAliveNameArr.push(item.name);
        if (item.children?.length) getKeepAliveRouterName(item.children, keepAliveNameArr);
    });
    return keepAliveNameArr;
}

export const $get = getValueByProp;

/**时间格式化 */
export const dateFormat = (str?: string | Date | Moment, format: string = DATE_PICKER_FORMAT) =>
    str ? moment(str).format(format).replace("Invalid date", DEFAULT_VALUE) : DEFAULT_VALUE;
export const dateTimeFormat = (str?: string | Date | Moment, format: string = DATETIME_PICKER_FORMAT) =>
    str ? moment(str).format(format).replace("Invalid date", DEFAULT_VALUE) : DEFAULT_VALUE;
export const dateFullTimeFormat = (str?: string | Date | Moment, format: string = LOG_DATE_FORMAT) =>
    str ? moment(str).format(format).replace("Invalid date", DEFAULT_VALUE) : DEFAULT_VALUE;

// 从待办跳转列表页，获取缓存状态
export const getDaiBanState = (routerName: string) => {
    const obj = JSON.parse(localStorage.getItem("MyTaskGotoList") || "{}");
    const keys = Object.keys(obj);
    if (!keys.length || !keys.includes(routerName)) return [];
    const key = keys[0];
    return [obj[key]];
};

// 下拉框清空待办状态
export const clearDaiBanState = (vals: number[], routerName: string) => {
    if (getDaiBanState(routerName)?.length && !vals.length) {
        localStorage.removeItem("MyTaskGotoList");
    }
};
